import RadioSelect from 'edge/platform/widgets/radioselect/components/RadioSelect';

export default angular.module('edge.platform.widgets.radioselect', []).component('gwRadioSelect', RadioSelect);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/radioselect/module.js
// module id = 1148
// module chunks = 0